<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Default look and feel" />
    <vc-breadcrumbs :links="links" />

    <example-title src="example-2.html" title="Custom color, router-link, last item not disabled" />
    <vc-breadcrumbs :links="links" tag="router-link" color="green" :last-disabled="false" />

    <example-title src="example-3.html" title="Center-aligned, router-link" />
    <vc-breadcrumbs :links="links" align="center" tag="router-link" color="red" />

    <example-title src="example-4.html" title="Right-aligned, router-link, uppercase" />
    <vc-breadcrumbs :upper-case="true" :links="links" align="right" tag="router-link" color="deep-purple" />

    <example-title src="example-5.html" title="Custom ASCII delimiters, router-link" />
    <vc-breadcrumbs delimiter="&raquo;" :links="links" tag="router-link" color="orange" />
    <vc-breadcrumbs delimiter="&gt;" :links="links" tag="router-link" color="green" />
    <vc-breadcrumbs delimiter="-" :links="links" tag="router-link" color="indigo" />

    <example-title src="example-6.html" title="Custom icon delimiters, router-link" />
    <vc-breadcrumbs delimiter="chevron_right" :links="links" tag="router-link" color="pink" />
    <vc-breadcrumbs delimiter="forward" :links="links" tag="router-link" color="blue" />
    <vc-breadcrumbs delimiter="skip_next" :links="links" tag="router-link" color="red" />

    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'BreadcrumbsPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      links: [{
        title: 'Home',
        to: '/'
      }, {
        title: 'Components',
        to: '/components'
      }, {
        title: 'Breadcrumbs',
        to: '/components/breadcrumbs'
      }]
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/breadcrumbs.vue